export default "__VITE_ASSET__240c7d55__"